import type { Layout } from 'react-grid-layout'

// There is an analogous list on: libs/spark/feature-dashboard-widgets/src/lib/widgets/WidgetNames.ts being used for unknown reasons.
export type WidgetName =
    | 'BiddersThisWeek'
    | 'BirthdaysThisWeek'
    | 'PipelineVehicleListings'
    | 'MyContactLogFollowups'
    | 'NeedPhotos'
    | 'NeedPhotosPreSale'
    | 'NeedCRPreSale'
    | 'NewCustomersThisWeek'
    | 'VehiclesCheckedInCount'
    | 'ConsignedVehicles'
    | 'SalesThisWeek'
    | 'SalesLastWeek'
    | 'SalesNextWeek'
    | 'VDPViews'
    | 'WatchedVehicles'
    | 'SearchCard'
    | 'Favorites'
    | 'ContactLogSearchCard'
    | 'PendingOffers'
    | 'PendingArbitrations'
    | 'NeedsTitles'
    | 'DMSVehicles'
    | 'RegisteredNextWeek'
    | 'FavoriteBuyers'
    | 'FavoriteSellers'
    | 'VehiclesWithDocuments'
    | 'EligiblePSI'
    | 'PSIOrderedTotal'
    | 'PSIOrderedSpark'
    | 'PSIOrderedAMS'
    | 'PSIOrderedPipeLine'
    | 'UnifiedAPIEligiblePSI'
    | 'CompletedVehicles'
    | 'BetaIfs'
/** All properties on this config must be optional!! */

export enum DataField {
    NONE = 'none',
    TOTAL = 'total',
    CONVERSION = 'conversion',
    SOLD = 'sold',
    RAN = 'ran',
    SUM_SALE_AMOUNT = 'sumSaleAmount',
    AVG_SALE_AMOUNT = 'avgSaleAmount',
    COMPLETED = 'completed',
}

export type DataFieldValues = `${DataField}`

export type SearchNumber = {
    dataField: DataFieldValues
    /** @deprecated Using Enum */
    leftLabel?: string
    /** @deprecated Using Enum */
    rightLabel?: string
}

export interface SearchCardConfig {
    searchString: string
    primary?: SearchNumber
    lowerLeft?: SearchNumber
    lowerRight?: SearchNumber
    searchDetailView?: string
    searchDetailTitle?: string
}

export interface ContactLogCardSearchConfig {
    searchString: string
    primary?: SearchNumber
    lowerLeft?: SearchNumber
    lowerRight?: SearchNumber
    searchDetailView?: string
    searchDetailTitle?: string
}

export type WeekModifier = 0 | 1 | -1

export interface GenericWidgetConfig {
    /* Search Cards only ...until refactor normal db cards */
    title?: string
    /** Metric Name */
    label?: string
    label2?: string
    sublabel?: string
    linklabel?: string
    linkurl?: string
    /* normal db cards */
    text?: string
    text2?: string
    secondaryText?: string
    offset?: DateOffset
    weekModifier?: WeekModifier
    search?: SearchCardConfig
    contactLogSearch?: ContactLogCardSearchConfig
    /** Numbers in array corespond to workflows added to card
     *
     * ex: workflows = [1] -> defaultWorkflows with ordinal === 1 added to card (WorkflowsView.tsx) */
    workflows?: number[]
}

export interface DashboardCardDef {
    id: string
    type: WidgetName
    config?: GenericWidgetConfig
    width: number
    height: number
    gridLayouts?: DashboardCardLayout<Layout>
    /** Locked means admins only should be able to edit card */
    locked?: boolean
    /** No one should be able to edit the card */
    readOnly?: boolean
    /** Numbers in array corespond to workflows added to card
     *
     * ex: workflows = [1] -> defaultWorkflows with ordinal === 1 added to card (WorkflowsView.tsx) */
    workflows?: number[]
}

export interface DashboardLayout {
    active?: boolean
    id: string
    name: string
    version?: number
    cards: DashboardCardDef[]
}

interface DashboardCardLayout<T> {
    [size: string]: T
}

export interface DashboardCardDef {
    id: string
    type: WidgetName
    config?: GenericWidgetConfig
    width: number
    height: number
    gridLayouts?: DashboardCardLayout<Layout>
    /** Locked means admins only should be able to edit card */
    locked?: boolean
    /** No one should be able to edit the card */
    readOnly?: boolean
    /** Associate card with a specific feature or service */
    featureFlags?: FeatureSet
}

export interface FeatureSet {
    include?: string[]
    exclude?: string[]
}

export type SearchCardTypes = 'CONTACT_LOG' | 'SEARCH' | 'STATIC'

/** Offsets are 0-based integers based on today.
 *
 * Past dates are negative, future dates are positive.
 * @param start should be less than end.
 * @param end must be greater than start.
 */
export interface DateOffset {
    start: number
    end: number
}

export interface DateOffsetsAsStrings {
    startDate: string
    endDate: string
}
